import {
  REFERENCE_SEARCH_CLEAR,
  REFERENCE_SEARCH_REQUEST,
  REFERENCE_SEARCH_CLEAR_REDIRECT,
  REFERENCE_HAVE_REQUEST,

  REFERENCE_SEARCH_EQ_REGION_REQUEST,
  REFERENCE_SEARCH_EQ_COUNTRY_REQUEST,
  REFERENCE_SEARCH_EQ_AREA_REQUEST,

  REFERENCE_SEARCH_VOL_COUNTRY_REQUEST,
  REFERENCE_SEARCH_VOL_REGION_REQUEST,
  REFERENCE_SEARCH_VOL_VOLCANO_NAMES_REQUEST,
  REFERENCE_SEARCH_VOL_MORPHOLOGIES_REQUEST,

  REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_REQUEST,
  REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST,
  REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_REQUEST,
  REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_REQUEST,
  REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_REQUEST,

  REFERENCE_SEARCH_TSUNAMI_REGIONS_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_COUNTRIES_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_AREAS_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_CAUSES_REQUEST,
  REFERENCE_SEARCH_TSUNAMI_VALIDITIES_REQUEST,

  REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_REQUEST,
  REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_REQUEST,
  REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_REQUEST,
  REFERENCE_SEARCH_DEPOSIT_COUNTRIES_REQUEST,

  REFERENCE_SEARCH_RUNUP_REGIONS_REQUEST,
  REFERENCE_SEARCH_RUNUP_COUNTRIES_REQUEST,
  REFERENCE_SEARCH_RUNUP_AREAS_REQUEST,
  REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_REQUEST,
  REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_REQUEST,
  REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_REQUEST,
  REFERENCE_SEARCH_RUNUP_CAUSES_REQUEST,
  REFERENCE_SEARCH_RUNUP_VALIDITIES_REQUEST,

} from './referenceSearchReducer';

export const searchReferences = ({
  queryParameters, formModel, location, searchRedirect, history,
}) => ({
  type: REFERENCE_SEARCH_REQUEST, queryParameters, formModel, location, searchRedirect, history,
});
export const clearReferenceSearch = () => ({ type: REFERENCE_SEARCH_CLEAR });
export const clearRedirect = () => ({ type: REFERENCE_SEARCH_CLEAR_REDIRECT });
export const getHaves = ({ history }) => ({ type: REFERENCE_HAVE_REQUEST, history });

export const getEqRegions = ({ history }) => ({ type: REFERENCE_SEARCH_EQ_REGION_REQUEST, history });
export const getEqCountries = ({ history }) => ({ type: REFERENCE_SEARCH_EQ_COUNTRY_REQUEST, history });
export const getEqAreas = ({ eqCountry, history }) => ({ type: REFERENCE_SEARCH_EQ_AREA_REQUEST, eqCountry, history });

export const getVolCountries = ({ history }) => ({ type: REFERENCE_SEARCH_VOL_COUNTRY_REQUEST, history });
export const getVolRegions = ({ history }) => ({ type: REFERENCE_SEARCH_VOL_REGION_REQUEST, history });
export const getVolVolcanoNames = ({ history }) => ({ type: REFERENCE_SEARCH_VOL_VOLCANO_NAMES_REQUEST, history });
export const getVolMorphologies = ({ history }) => ({ type: REFERENCE_SEARCH_VOL_MORPHOLOGIES_REQUEST, history });

export const getVolLocCountries = ({ history }) => ({ type: REFERENCE_SEARCH_VOLCANO_LOCATION_COUNTRY_REQUEST, history });
export const getVolLocRegions = ({ history }) => ({ type: REFERENCE_SEARCH_VOLCANO_LOCATION_REGION_REQUEST, history });
export const getVolLocMorphologies = ({ history }) => ({ type: REFERENCE_SEARCH_VOLCANO_LOCATION_MORPHOLOGY_REQUEST, history });
export const getVolLocStatuses = ({ history }) => ({ type: REFERENCE_SEARCH_VOLCANO_LOCATION_STATUS_REQUEST, history });
export const getVolLocEruptionTimes = ({ history }) => ({ type: REFERENCE_SEARCH_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST, history });

export const getTsuRegions = ({ history }) => ({ type: REFERENCE_SEARCH_TSUNAMI_REGIONS_REQUEST, history });
export const getTsuCountries = ({ history }) => ({ type: REFERENCE_SEARCH_TSUNAMI_COUNTRIES_REQUEST, history });
export const getTsuAreas = ({ tsuCountry, history }) => ({ type: REFERENCE_SEARCH_TSUNAMI_AREAS_REQUEST, tsuCountry, history });
export const getTsuRunupCountries = ({ history }) => ({ type: REFERENCE_SEARCH_TSUNAMI_RUNUP_COUNTRIES_REQUEST, history });
export const getTsuRunupAreas = ({ tsuRunupCountry, history }) => ({ type: REFERENCE_SEARCH_TSUNAMI_RUNUP_AREAS_REQUEST, tsuRunupCountry, history });
export const getTsuRunupMeasurementTypes = ({ history }) => ({ type: REFERENCE_SEARCH_TSUNAMI_RUNUP_MEASUREMENT_TYPES_REQUEST, history });
export const getTsuValidities = ({ history }) => ({ type: REFERENCE_SEARCH_TSUNAMI_VALIDITIES_REQUEST, history });
export const getTsuCauses = ({ history }) => ({ type: REFERENCE_SEARCH_TSUNAMI_CAUSES_REQUEST, history });

export const getDepPublications = ({ history }) => ({ type: REFERENCE_SEARCH_DEPOSIT_PUBLICATIONS_REQUEST, history });
export const getDepGeologicAges = ({ history }) => ({ type: REFERENCE_SEARCH_DEPOSIT_GEOLOGIC_AGES_REQUEST, history });
export const getDepBodiesOfWater = ({ history }) => ({ type: REFERENCE_SEARCH_DEPOSIT_BODIES_OF_WATER_REQUEST, history });
export const getDepCountries = ({ history }) => ({ type: REFERENCE_SEARCH_DEPOSIT_COUNTRIES_REQUEST, history });

export const getRunupRegions = ({ history }) => ({ type: REFERENCE_SEARCH_RUNUP_REGIONS_REQUEST, history });
export const getRunupCountries = ({ history }) => ({ type: REFERENCE_SEARCH_RUNUP_COUNTRIES_REQUEST, history });
export const getRunupAreas = ({ runupCountry, history }) => ({ type: REFERENCE_SEARCH_RUNUP_AREAS_REQUEST, runupCountry, history });
export const getRunupRunupCountries = ({ history }) => ({ type: REFERENCE_SEARCH_RUNUP_RUNUP_COUNTRIES_REQUEST, history });
export const getRunupRunupAreas = ({ runupRunupCountry, history }) => ({ type: REFERENCE_SEARCH_RUNUP_RUNUP_AREAS_REQUEST, runupRunupCountry, history });
export const getRunupRunupMeasurementTypes = ({ history }) => ({ type: REFERENCE_SEARCH_RUNUP_RUNUP_MEASUREMENT_TYPES_REQUEST, history });
export const getRunupCauses = ({ history }) => ({ type: REFERENCE_SEARCH_RUNUP_CAUSES_REQUEST, history });
export const getRunupValidities = ({ history }) => ({ type: REFERENCE_SEARCH_RUNUP_VALIDITIES_REQUEST, history });
